import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import Button from '../../shared/components/FormElements/Button/Button';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Upgrade.css';
import MainNavigation from '../../components/MainNavigation';

const Upgrade = () => {
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const [user, setUser] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    useEffect(()=>{
        const fetchUser = async() => {
            try {
                const response = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+`/user/${auth.userId}`);
                setUser(response.user);
            } catch (err) {
                console.log(err);
            }
        };
        fetchUser();
    }, [sendRequest, auth]);

    const buyTenHandler = async event => {
        event.preventDefault();
        try {
            const response = await sendRequest('https://vace-stripe-13c5af40b419.herokuapp.com/checkout', 'POST', 
            JSON.stringify({
                userId: auth.userId,
                plan: 'ten'
            }),
            {'Content-Type':'application/json'}
            );

            window.open(response.url);
            navigate('/account');
        } catch (err) {
            console.log(err);
        }
    };

    const subscribeHandler = async event => {
        event.preventDefault();
        try {
            const response = await sendRequest('https://vace-stripe-13c5af40b419.herokuapp.com/checkout', 'POST', 
            JSON.stringify({
                userId: auth.userId,
                plan: 'pro'
            }),
            {'Content-Type':'application/json'}
            );

            window.open(response.url);
            navigate('/account');
        } catch (err) {
            console.log(err);
        }
    };

    const unsubscribeHandler = async event => {
        event.preventDefault();
        try {
            const response = await sendRequest('https://vace-stripe-13c5af40b419.herokuapp.com/cancel', 'POST', 
            JSON.stringify({
                userId: auth.userId,
            }),
            {'Content-Type':'application/json'}
            );

            navigate('/account');
        } catch (err) {
            console.log(err);
        }
    };

    return <React.Fragment>
        {!isLoading && <MainNavigation />}
        <div className='upgrade-page'>
            <ErrorModal error={error} onClear={clearError}/>
            {isLoading && <div className='center'>
                <LoadingSpinner asOverlay />
            </div>}
            {!isLoading && <div className='upgrade-titles'>
                <h1>Upgrade</h1>
                <p style={{ fontWeight: 'light' }}>Upgrade your plan to further improve your interview skills.</p>
            </div>
            }
            {!isLoading && user && (user.plan === 'free') &&
            <motion.div
            className="plans"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.25, duration: 0.5 }}
            >
            <div className="freeplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-person.svg" />
                    <div className="individual">Individual</div>
                </div>
                <b className="free">Free</b>
                <div className="div">$0</div>
                </div>
                <div className="plancontent">
                <div className="session-month">1 Session / month</div>
                <div className="session-month">5 Questions / month</div>
                <div className="session-month">10 Feedbacks / month</div>
                </div>
                
            </div>
            <div className="freeplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-person.svg" />
                    <div className="individual">Individual</div>
                </div>
                <b className="free1">10 Feedbacks</b>
                <div className="div">$5</div>
                </div>
                <div className="plancontent">
                <div className="session-month">1 Session</div>
                <div className="session-month">5 Questions</div>
                <div className="session-month">10 Feedbacks</div>
                </div>
                <motion.div
                className="planbutton"
                whileHover={{ scale: 1.1, x: -5 }}
                whileTap={{ scale: 0.9, x:0 }}
                >
                <div className="signup">
                    <div className="sign-up"><Button onClick={buyTenHandler} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>BUY NOW</p></Button></div>
                </div>
                </motion.div>
            </div>
            <div className="proplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-person.svg" />
                    <div className="individual">Individual</div>
                </div>
                <b className="free">Pro</b>
                <div className="div">$10 / mo</div>
                </div>
                <div className="plancontent">
                <div className="session-month">5 Sessions / month</div>
                <div className="session-month">100 Questions / month</div>
                <div className="session-month">200 Feedbacks / month</div>
                <div className="session-month">Progress Tracking</div>
                </div>
                <motion.div
                className="planbutton"
                whileHover={{ scale: 1.1, x: -5 }}
                whileTap={{ scale: 0.9, x:0 }}
                >
                <div className="signup">
                    <div className="sign-up"><Button onClick={subscribeHandler} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>SUBSCRIBE</p></Button></div>
                </div>
                </motion.div>
            </div>
            <div className="proplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-people.svg" />
                    <div className="individual">Institution</div>
                </div>
                <b className="free">Edu</b>
                <div className="div">$2,000+ / mo</div>
                </div>
                <div className="plancontent">
                <div className="session-month">100 Sessions / month</div>
                <div className="session-month">2000 Questions / month</div>
                <div className="session-month">4000 Feedbacks / month</div>
                <div className="session-month">{`Customizable Criteria `}</div>
                <div className="session-month">Progress Tracking</div>
                </div>
                <motion.div
                className="planbutton"
                whileHover={{ scale: 1.1, x: -5 }}
                whileTap={{ scale: 0.9, x:0 }}
                >
                <div className="signup">
                    <div className="sign-up"><Button to={'mailto:propagate.jpn@gmail.com'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>CONTACT US</p></Button></div>
                </div>
                </motion.div>
            </div>
            </motion.div>
            }
            {!isLoading && user && (user.plan === 'pro') &&
            <motion.div
            className="plans"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.25, duration: 0.5 }}
            >
            <div className="freeplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-person.svg" />
                    <div className="individual">Individual</div>
                </div>
                <b className="free">Free</b>
                <div className="div">$0</div>
                </div>
                <div className="plancontent">
                <div className="session-month">1 Session / month</div>
                <div className="session-month">5 Questions / month</div>
                <div className="session-month">10 Feedbacks / month</div>
                </div>
                
            </div>
            <div className="freeplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-person.svg" />
                    <div className="individual">Individual</div>
                </div>
                <b className="free1">10 Feedbacks</b>
                <div className="div">$5</div>
                </div>
                <div className="plancontent">
                <div className="session-month">1 Session</div>
                <div className="session-month">5 Questions</div>
                <div className="session-month">10 Feedbacks</div>
                </div>
                <motion.div
                className="planbutton"
                whileHover={{ scale: 1.1, x: 0 }}
                whileTap={{ scale: 0.9, x:0 }}
                >
                <div className="signup">
                    <div className="sign-up"><Button onClick={buyTenHandler} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>BUY NOW</p></Button></div>
                </div>
                </motion.div>
            </div>
            <div className="proplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-person.svg" />
                    <div className="individual">Individual</div>
                </div>
                <b className="free">Pro</b>
                <div className="div">$10 / mo</div>
                </div>
                <div className="plancontent">
                <div className="session-month">5 Sessions / month</div>
                <div className="session-month">100 Questions / month</div>
                <div className="session-month">200 Feedbacks / month</div>
                <div className="session-month">Progress Tracking</div>
                </div>
                <motion.div
                className="planbutton"
                whileHover={{ scale: 1.1, x: 0 }}
                whileTap={{ scale: 0.9, x:0 }}
                >
                <div className="cancel-subs">
                    <div className="cancel-button"><Button onClick={unsubscribeHandler} transparent><p style={{ color: '#black', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>CANCEL</p></Button></div>
                </div>
                </motion.div>
            </div>
            <div className="proplan">
                <div className="plantitle">
                <div className="target">
                    <img className="icon-person" alt="" src="/-icon-people.svg" />
                    <div className="individual">Institution</div>
                </div>
                <b className="free">Edu</b>
                <div className="div">$2,000+ / mo</div>
                </div>
                <div className="plancontent">
                <div className="session-month">100 Sessions / month</div>
                <div className="session-month">2000 Questions / month</div>
                <div className="session-month">4000 Feedbacks / month</div>
                <div className="session-month">{`Customizable Criteria `}</div>
                <div className="session-month">Progress Tracking</div>
                </div>
                <motion.div
                className="planbutton"
                whileHover={{ scale: 1.1, x: 0 }}
                whileTap={{ scale: 0.9, x:0 }}
                >
                <div className="signup">
                    <div className="sign-up"><Button to={'mailto:propagate.jpn@gmail.com'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>CONTACT US</p></Button></div>
                </div>
                </motion.div>
            </div>
            </motion.div>
            }
        </div>
    </React.Fragment>
};

export default Upgrade;